import { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { Box, CircularProgress } from '@mui/material';
import axiosSmartSurvey from '../../api/axios';

export default function PtasPrint() {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [searchParams] = useSearchParams();
    const fileName = searchParams.get("fileName");

    useEffect(() => {
        if (fileName) {
            axiosSmartSurvey.get(`/ptas/download/${fileName}`, {
                responseType: 'blob' // ⭐ บอก axios ให้ตอบกลับเป็น blob
            })
                .then((res) => {
                    console.log(res)
                    const url = URL.createObjectURL(res.data);
                    setPdfUrl(url);
                })
                .catch((err) => {
                    console.error("Error loading PDF:", err);
                });
        }
    }, [fileName]);

    return (
        <Box>
            {pdfUrl ? (
                <iframe
                    src={pdfUrl}
                    width="100%"
                    height="1200px"
                    title="PDF Preview"
                    style={{ border: "1px solid #ccc" }}
                />
            ) : (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress />
                </Box>
            )}
        </Box>
    );
}
